import type { ComposerPrefill } from "../hub/hub-context.ts"
import type { Channel, ContactRef, RecordRef } from "../types/compose.types.ts"

/** A record page's "write to this person about this record". */
export interface ComposerTarget {
  record: RecordRef
  recipient: ContactRef
  recipientName: string
  recordLabel?: string
  channel?: Channel
}

export const targetToPrefill = (target: ComposerTarget): ComposerPrefill => ({
  channel: target.channel,
  record: {
    ...target.record,
    label: target.recordLabel ?? target.recipientName
  },
  recipients: [{ ...target.recipient, name: target.recipientName }]
})
